var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"type":"primary","disabled":_vm.disable},on:{"click":function($event){return _vm.toCode()}}},[(_vm.countFlag)?_c('span',[_vm._v("获取验证码")]):_c('span',[_vm._v("剩余"+_vm._s(_vm.countNum)+"S")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }